import {initDocumentDownloads} from "./common";

export function initRenteAanbod() {

    initDocumentDownloads();
}